import React from 'react';
import Logo from '../../assets/images/Main-logo.png';
import Icon1 from '../../assets/images/icon-53.png';
import Icon2 from '../../assets/images/icon-54.png';
import Icon3 from '../../assets/images/icon-55.png';
import { Link } from 'react-router-dom';
import { config } from '../pages/config';

import payment1 from '../../assets/images/payment/VISA.png';
import payment2 from '../../assets/images/payment/MASTERCARD.png';
import payment3 from '../../assets/images/payment/MAESTRO.png';
import payment4 from '../../assets/images/payment/DINERSCLUB.jpg';
import payment5 from '../../assets/images/payment/DISCOVER.png';
import payment6 from '../../assets/images/payment/APPLEPAY.png';
import payment7 from '../../assets/images/payment/GOOGLEPAY.png';

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <div>
      <footer className="main-footer">
        <div className="bg-layer"></div>
        <div className="footer-top">
          <div className="auto-container">
            <div className="row clearfix justify-content-between">
              <div className="col-lg-3 col-md-6 col-sm-12 footer-column">
                <div className="footer-widget logo-widget">
                  <figure className="footer-logo p-3 bg-white">
                    <Link to={`${config.appUrl}`}>
                      <img src={Logo} alt="Precision Driving School Logo" />
                    </Link>
                  </figure>
                  <p className="text-white mb-3" style={{ fontSize: '14px', lineHeight: '1.6' }}>
                    Precision Driving School is a trusted Driving School in Leicester offering Automatic Driving Lessons, Manual Driving Lessons, Intensive Driving Courses and Refresher Driving Lessons. Our experienced instructors help learners across Leicester and surrounding areas become safe, confident drivers.
                  </p>
                  <h4>We Accept</h4>
                  <div>
                    <img
                      src={payment1}
                      alt="paymentOptionImage"
                      className="payment_logo"
                    />
                    <img
                      src={payment2}
                      alt="paymentOptionImage"
                      className="payment_logo"
                    />
                    <img
                      src={payment3}
                      alt="paymentOptionImage"
                      className="payment_logo"
                    />
                    <img
                      src={payment4}
                      alt="paymentOptionImage"
                      className="payment_logo"
                    />
                    <img
                      src={payment5}
                      alt="paymentOptionImage"
                      className="payment_logo"
                    />
                    <img
                      src={payment6}
                      alt="paymentOptionImage"
                      className="payment_logo"
                    />
                    <img
                      src={payment7}
                      alt="paymentOptionImage"
                      className="payment_logo"
                    />
                  </div>
                  <p className="mt-3">Security provided by NatWest</p>
                </div>
              </div>
              <div className="col-lg-5 col-md-6 col-sm-12 footer-column">
                <div className="d-flex justify-content-between justify-content-md-evenly">
                  <div className="footer-widget links-widget">
                    <div className="widget-title">
                      <h4>Quick Links</h4>
                    </div>
                    <div className="widget-content">
                      <ul className="links-list clearfix">
                        <li>
                          <Link to={`${config.appUrl}courses`}>
                            <i className="bi bi-book me-2 text-green"></i>Our Courses
                          </Link>
                        </li>
                        <li>
                          <Link to={`${config.appUrl}instructors`}>
                            <i className="bi bi-people me-2 text-green"></i>Our Instructors
                          </Link>
                        </li>
                        <li>
                          <Link to={`${config.appUrl}faqs`}>
                            <i className="bi bi-patch-question me-2 text-green"></i>FAQs
                          </Link>
                        </li>
                        <li>
                          <Link to={`${config.appUrl}contact-us`}>
                            <i className="bi bi-envelope me-2 text-green"></i>Contact Us
                          </Link>
                        </li>
                        <li>
                          <a
                            href={`${config.ClientUrl}`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i className="bi bi-person-plus me-2 text-green"></i>Register As Instructor
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="footer-widget links-widget ps-md-0 ps-4">
                    <div className="widget-title">
                      <h4>Important Link</h4>
                    </div>
                    <div className="widget-content">
                      <ul className="links-list clearfix">
                        <li>
                          <Link to={`${config.appUrl}how-to-become-instructor`}>
                            <i className="bi bi-person-vcard me-2 text-green"></i>Become an Instructor
                          </Link>
                        </li>
                        <li>
                          <Link to={`${config.appUrl}about-practical-test`}>
                            <i className="bi bi-calendar-check me-2 text-green"></i>Book Practical Test
                          </Link>
                        </li>
                        <li>
                          <Link to={`${config.appUrl}about-theory-test`}>
                            <i className="bi bi-journal-check me-2 text-green"></i>Book Theory Test
                          </Link>
                        </li>
                        <li>
                          <a
                            href={`https://www.gov.uk/government/organisations/driver-and-vehicle-standards-agency`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i className="bi bi-shield-check me-2 text-green"></i>DVSA Website
                          </a>
                        </li>
                        <li>
                          <Link to={`${config.appUrl}blogs`}>
                            <i className="bi bi-newspaper me-2 text-green"></i>Blog & News
                          </Link>
                        </li>
                        <li>
                          <Link to={`${config.appUrl}refresher-driver-lessons`}>
                            <i className="bi bi-arrow-repeat me-2 text-green"></i>Refresher driver lessons
                          </Link>
                        </li>
                        <li>
                          <a
                            href={`https://www.safedrivingforlife.info/advice/car-driving/how-drive-car/`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i className="bi bi-question-circle me-2 text-green"></i>How to drive a car?
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12 footer-column">
                <div className="footer-widget gallery-widget">
                  <div className="widget-title">
                    <h4>Contact Details</h4>
                  </div>
                  <div className="widget-content row align-items-center">
                    <div className="single-item col-md-6 mb-4 d-flex d-xl-block">
                      <div className="icon-box">
                        <img src={Icon1} alt="" width="35" />
                      </div>
                      <div className="ps-4 ps-xl-0">
                        <h5 className="text-white mb-2 mt-0 mt-xl-2">
                          We are Here
                        </h5>
                        <p className="" style={{ fontSize: '14px' }}>
                          4 Rivers Street, Leicester,{' '}
                          <br className="d-none d-xl-none" />
                          England, LE3 5RX
                        </p>
                      </div>
                    </div>
                    <div className="single-item col-md-6 mb-4 d-flex d-xl-block">
                      <div className="icon-box">
                        <img src={Icon2} alt="" width="35" />
                      </div>
                      <div className="ps-4 ps-xl-0">
                        <h5 className="text-white mb-2 mt-0 mt-xl-2">
                          Quick Contact
                        </h5>
                        <div>
                          <a
                            href="tel:0116 210 2688"
                            style={{ fontSize: '14px', color: '#74757b' }}
                          >
                            <span style={{ whiteSpace: 'nowrap' }}><i className="bi bi-telephone" style={{ marginRight: '6px' }}></i>0116 210 2688</span>
                          </a>
                        </div>
                        <div>
                          <a
                            href="tel:+44 7380 851496"
                            style={{ fontSize: '14px', color: '#74757b' }}
                          >
                            <span style={{ whiteSpace: 'nowrap' }}><i className="bi bi-telephone" style={{ marginRight: '6px' }}></i>+44 7380 851496</span>
                          </a>
                        </div>
                        <div>
                          <a
                            href="mailto:info@precisiondriving.uk"
                            style={{ fontSize: '14px', color: '#74757b' }}
                          >
                            <span style={{ whiteSpace: 'nowrap' }}><i className="bi bi-envelope" style={{ marginRight: '6px' }}></i>info@precisiondriving.uk</span>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="single-item col-md-6 d-flex d-xl-block">
                      <div className="icon-box">
                        <img src={Icon3} alt="" width="35" />
                      </div>
                      <div className="ps-4 ps-xl-0">
                        <h5 className="text-white mb-2 mt-0 mt-xl-2">Opening Hours</h5>
                        <p style={{ fontSize: '14px' }}>
                          <span className="text-white">Mon-Fri:</span> <br />{' '}
                          8:00 AM – 6:00 PM <br />
                          <span className="text-white">
                            Saturday:
                          </span> <br /> 10:00 AM – 2:00 PM <br />
                          <span className="text-white">
                            Sunday:
                          </span> <br /> Closed
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6 single-item mt-4">
                      <h5 className="text-white mb-2">Follow Us</h5>
                      <ul className="social-links mt-md-0 mt-4 clearfix d-flex gap-2">
                        <li>
                          <a
                            target="_blank"
                            href="https://www.facebook.com/PrecisionDrivingSchoolLimited"
                            rel="noreferrer"
                          >
                            <i className="bi bi-facebook"></i>
                          </a>
                        </li>
                        <li>
                          <a
                            target="_blank"
                            href="https://www.instagram.com/precisiondriving_leicester/"
                            rel="noreferrer"
                          >
                            <i className="bi bi-instagram"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom d-md-flex justify-content-between auto-container">
          <div className="auto-containers py-md-0 py-4">
            <ul className="list gap-3">
              <li>
                <Link to={`${config.appUrl}privacy-policy`}>
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to={`${config.appUrl}cookie-policy`}>Cookie Policy</Link>
              </li>
              <li>
                <Link to={`${config.appUrl}terms-and-conditions`}>
                  Terms &amp; Conditions
                </Link>
              </li>
              <li>
                <Link to={`${config.appUrl}refund-and-Delivery`}>
                  Refund & Delivery
                </Link>
              </li>
            </ul>
          </div>
          <div className="px-md-0  px-4">
            <p>
              Copyrights{' '}
              <span>
                © {year} <span>Precision Driving</span>.
              </span>{' '}
              Design By{' '}
              <span>
                <a
                  href="https://www.zithas.co.uk"
                  className="text-green"
                  target="blank"
                >
                  {' '}
                  Zithas Technologies
                </a>
              </span>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
